import { styled } from '@material-ui/core';

import { Container } from 'shared/components/container/Container';

export const StyledContainer = styled(Container)({
  // 280 - footer height/ 50 - separator height
  minHeight: 'calc(100vh - (280px + 50px))',
});
